/** @format */

import React, { useReducer } from "react";
import swal from "sweetalert";
import moment from "moment";
import axios from "axios";
import UserContext from "./UserContext";
import UserReducer from "./UserReducer";
import { globales, mensajeglobales } from "../../helpers/Confi";
import { CodificaString, DecodificanString } from "../../helpers/Codifican";
import {
  GET_IC,
  GET_IC_MODAL,
  GET_SOCIOS_SOCIEDADES,
  GET_SOCIOS_SOCIEDADES_MODAL,
  GET_DETALLE_CONYUGE,
  GET_DETALLE_CONYUGE_MODAL,
  GET_DETALLE_DIRECCIONES,
  GET_DETALLE_DIRECCIONES_MODAL,
  GET_DETALLE_PROPIEDADES_BIENES,
  GET_DETALLE_PROPIEDADES_BIENES_MODAL,
  GET_DETALLE_BOLETIN,
  GET_DETALLE_BOLETIN_MODAL,
  GET_DETALLE_VEHICULO,
  GET_DETALLE_VEHICULO_MODAL,
  ASIGNO_DIGITO_VERIFICADOR,
  ASIGNO_RUT_CONSULTA,
  GET_DOCUMENT_PCH,
  GET_DETALLE_EXTRACTO,
  ASIGNO_NSERIES_EMPRESA,
  ASIGNO_ESTADO_CARGA,
  GET_ESTRUCTURA_FINANCIERA,
  GetOnp,
  GetBanco,
  AuthLogin,
  GetPerfil,
  GetPermisos,
  GetContraInfoCom,
  GetContraVerifOnp,
  GetSoporte,
  GetUsuarios,
  GetResumen,
  GetDetalle,
  GetResumenGrafico,
  GetProducts,
  LogoutAll,
  GetUrlBase,
  get_TipoContrato,
  GetConsumoSaldno,
  types,
  GET_ESTRUCTURA_FINANCIERA_MODAL,
  STATE_OK_LOADING_IC,
  code_error,
} from "../types";

const UserState = (props) => {
  const initialState = {
    datoIC: [],
    datoICMODAL: [], // DATA INFORME COMERCIAL
    datoICPDF: [], // DATA INFORME COMERCIAL PDF,S
    DatoListaSA: [], //DATOS SOCIO Y SOCIEDADES
    DatoListaSAModal: [], //DATOS SOCIO Y SOCIEDADES
    DatoError: false,
    scoreDatospdf: null,
    Datodetalleconyuge: null,
    DatodetalleconyugeModal: null,
    DatodetalleDirecciones: [],
    DatodetalleDireccionesModal: null,
    DatodetallePropBienes: [],
    DatodetallePropBienesModal: [],
    DatodetalleBoletin: [],
    DatodetalleBoletinModal: [],
    DatodetalleBoletinpdfModal: [],
    DatodetalleVehiculos: [],
    DatodetalleVehiculosModal: [],
    DatodetalleVerificacion: [],
    DatodetalleDocumentpch: [],
    DatadetalleExtracto: null,
    RutConsulta: null,
    SerieCedulaNatu: null,
    RutDv: null,
    DvValidado: null,
    RutValidado: 0,
    stateLoading: false,
    SklDecode: "",

    DataOnp: [],
    DataBanco: [],
    DataForm: [],
    DataLogin: [], 
    DataPerfil: [],
    DataPermisos: {},
    DataContatoInfoCom: {},
    DataContratoVerifOnp: {},

    DataDetalle: {},
    DataResumen: [],
    DataUsuarios: [],
    DataSoporte: {},

    DataResumenGrafico: {},
    dataDetalleEstructura: [],
    dataDetalleEstructuraModal: [],

    Banco: null,
    CtaCte: null,
    SerieRut: null,
    Monto: null,
    NroDoc: null,
    DataProducts: [],
    DataLogoutAll: [],
    DataTipoContracto: [],
    DataSaldo: [],
    dataUrlBase: null,
    statOkLoading: Boolean,
    loadingAuth: Boolean,
    codeError: null,
  };

  const [state, dispatch] = useReducer(UserReducer, initialState);

  const [RutConsulta, setRutConsulta] = React.useState(null);
  const [RutDv, setRutDv] = React.useState(null);
  const [RutConsultaModal, setRutConsultaModal] = React.useState(null);
  const [RutDvModal, setRutDvModal] = React.useState(null);

  const parametros = globales();
  const MSG = mensajeglobales();
  const clientIdd = DecodificanString(
    JSON.parse(localStorage.getItem("clientId"))
  );
  const ContractIdd = DecodificanString(
    JSON.parse(localStorage.getItem("contractId"))
  );

  const Authorizationn = JSON.parse(localStorage.getItem("jwt"));
  const apiKeyy = JSON.parse(localStorage.getItem("apiKey"));
  const AuthorizationIDD = JSON.parse(localStorage.getItem("tokenId"));
  const Userr = JSON.parse(localStorage.getItem("login"));

  const getUrlBase = (id, login) => {
    const idUser = DecodificanString(id);
    const userLogin = DecodificanString(login);
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      axios
        .post(
          `${parametros.URLAPISUCA}api/authority/url-base`,
          {
            userId: idUser,
            userLogin: userLogin,
            applicationId: parametros.applicationId,
          },
          {
            headers: {
              Authorization: Authorization,
              ApiKey: ApiKey,
            },
          }
        )
        .then((response) => {
          const data_urlhome = CodificaString(response.data.Url);
          localStorage.setItem("urlBaseHome", JSON.stringify(data_urlhome));          
          dispatch({ type: GetUrlBase, payload: data_urlhome });          
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.warn(error);
    }
  };

  const getProducts = async (id, login) => {
  
    const idUser = DecodificanString(id);
    const userLogin = DecodificanString(login);
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      axios
        .post(          
          `${parametros.URLAPISUCA}api/authority/productosusuario`,        
          {
            userId: idUser,
            userLogin: userLogin,
            applicationId: parametros.applicationId,
            productId: parametros.productId,
          },
          {
            headers: {
              Authorization: Authorization,
              ApiKey: ApiKey,
            },
          }
        )
        .then((respoProducts) => {          
          if (respoProducts !== "" || respoProducts !== null) {
            const rsp = CodificaString(JSON.stringify(respoProducts))            
            localStorage.setItem("prods", rsp)
            const dataProducts = respoProducts.data;
            dispatch({ type: GetProducts, payload: dataProducts });
          }          
        })        
    } catch (error) {
      console.warn(error);
    }
  };

  const getContractVerifOnp = async (id, login, clientId) => {
    const idUser = id;
    const userLogin = login;
    const idCliente = clientId;
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      const resp = await axios.post(
        `${parametros.URLAPISUCA}api/authority/contractvalidation`,
        {
          userId: idUser,
          userLogin: userLogin,
          applicationId: parametros.applicationId,
          clienteId: idCliente,
          contractTypeId: parametros.URLTIPOCONTRATOIDONP,
          
        },
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
          },
        }
      );

      if (resp !== "" || resp !== null) {

        const datosContractVerifOnp = resp.data;
        const ContratoVerifOnp = resp.data.Exist;
        const contratoOnp = CodificaString(resp.data.ContactId);

        dispatch({ type: GetContraVerifOnp, payload: datosContractVerifOnp });
        localStorage.setItem(
          "ContratoVerifOnp",
          JSON.stringify(ContratoVerifOnp)
        );
    
        localStorage.setItem("contratoOnp", JSON.stringify(contratoOnp));
      }
    } catch (error) {}
  };

  const getContractInfoCom = async (id, login, ClienteIdd, ContractTypeId) => {

    const idUser = id;
    const userLogin = login;
    const idCliente = ClienteIdd;
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
  
    try {
      const res = await axios.post(
        `${parametros.URLAPISUCA}api/authority/contractvalidation`,
        {
          userId: idUser,
          userLogin: userLogin,
          applicationId: parametros.applicationId,
          clienteId: idCliente,
          contractTypeId: ContractTypeId,
        },
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
          },
        }
      );

      if (res !== "" || res != null) {        
        
        const datosContractInfoCom = res.data;
        const ContratoInfoCom = CodificaString(res.data.Exist);    
        const contratoInfoComId = CodificaString(res.data.ContactId);

        if (!res.data.Exist) {
          if(ContractTypeId === 23) {
            swal({
              title: "Atención",
              text: "Estimado Cliente su contrato se encuentra vencido, comuníquese con su Ejecutivo de Ventas o a contacto@pch.cl",
              icon: "warning",
              button: "Ok",
            }).then(() => {
              localStorage.clear();
              dispatch({type: types.AuthLogout})
              //window.location.href = "InfoComPlus";
              window.location.href = 'https://www.pch.cl';
            });
          }
          
          return;
        } else {
          
          dispatch({ type: GetContraInfoCom, payload: datosContractInfoCom });
          localStorage.setItem(
            "ContratoInfoCom",
            JSON.stringify(ContratoInfoCom)
          );        
          localStorage.setItem(
            "contratoInfoComId",
            JSON.stringify(contratoInfoComId)
          );

        }

      }
    } catch (error) { alert("error")}
  };


  const getproductvalidation = async (id, login, clientId) => {
    const idUser = DecodificanString(id);
    const userLogin = DecodificanString(login);
    const idCliente = DecodificanString(clientId);
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      const res = await axios.post(
        `${parametros.URLAPISUCA}api/authority/productvalidation`,
        {
          userId: idUser,
          userLogin: userLogin,
          applicationId: parametros.applicationId,
          clienteId: idCliente,
          productId: parametros.productIdEeff,
        },
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
          },
        }
      );

      if (res !== "" || res != null) {
        const productvalidation = res.data.Exist;
        if (!productvalidation) {
          swal({
            title: "Atención",
            text: "Usuario inválido",
            icon: "warning",
            button: "Ok",
          }).then(() => {
            localStorage.clear();
            dispatch({type: types.AuthLogout})            
            window.location.href = 'https://www.pch.cl';            
            
          });
        }else {
          localStorage.setItem(
            "productvalidation",
            JSON.stringify(productvalidation)
          );
        }
      }
    } catch (error) { console.log(error)}
  };

  const getPermisos = async (datosPerfil, id, login, clientId) => {
    const idUser = id;
    const idPerfil = datosPerfil; 
    const userLogin = login;
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      const resultadoPermisos = await axios.post(
        `${parametros.URLAPISUCA}api/authority/permissions`,
        {
          userId: idUser,
          profileId: idPerfil,
          userLogin: userLogin,
          applicationId: parametros.applicationId,
        },
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
          },
        }
      );

      if (resultadoPermisos !== "" || resultadoPermisos !== null) {
        const datosPermisos = resultadoPermisos.data;

        dispatch({ type: GetPermisos, payload: datosPermisos });
        localStorage.setItem("datosPermisos", JSON.stringify(datosPermisos));
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const getPerfil = async (id, login, clientId) => {
    const idUser = DecodificanString(id);
    const userLogin = DecodificanString(login);
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      await axios
        .post(
          `${parametros.URLAPISUCA}api/authority/profile`,
          {
            userId: idUser,
            userLogin: userLogin,
            applicationId: parametros.applicationId,
            productId: parametros.productId,
          },
          {
            headers: {
              Authorization: Authorization,
              ApiKey: ApiKey,
            },
          }
        )
        .then((response) => {
          if (response !== "" || response !== null) {            
            const datosPerfil = response.data[0].id;            
            dispatch({ type: GetPerfil, payload: datosPerfil });
            getPermisos(datosPerfil, idUser, userLogin, clientId);
            const clientIdd = DecodificanString(
              JSON.parse(localStorage.getItem("clientId"))
            );
            const ContractIdd = DecodificanString(
              JSON.parse(localStorage.getItem("contractId"))
            );
            getTipoContracto(clientIdd, ContractIdd);
            
          }
        })        
    } catch (error) {
      console.warn(error);
    }
  };

  const getLogin = async (user, pass) => {

    localStorage.clear();
    localStorage.setItem("setConditionsProducts", JSON.stringify(false));

    try {
      await axios
        .post(`${parametros.URLAPISUCA}api/Authority`, {
          user,
          pass,
          applicationId: parametros.applicationId,
          productId: parametros.productId,
        })
        .then((response) => {
          if (response.data.autenticated) {
            const datosLogin = response.data;
            const tokenId = datosLogin.tokenId;
            const token = datosLogin.tokenValue;
            const apiKey = datosLogin.apiKey;

            const id = CodificaString(datosLogin.id);
            const login = CodificaString(datosLogin.login);
            const name = CodificaString(datosLogin.name);
            const clientId = CodificaString(datosLogin.clientId);
            const autenticado = CodificaString(datosLogin.autenticated);
            const contractId = CodificaString(datosLogin.contractId);
            localStorage.setItem("LNTONE", JSON.stringify(datosLogin.login));
            localStorage.setItem("log", JSON.parse(true));
            document.cookie = "PCHLOGOK=true";
            document.cookie = "SameSite=None";
            sessionStorage.setItem("pchcllog", JSON.parse(true));

            localStorage.setItem("autenticado", JSON.stringify(autenticado));
            localStorage.setItem("jwt", JSON.stringify(token));
            localStorage.setItem("tokenId", JSON.stringify(tokenId));
            localStorage.setItem("apiKey", JSON.stringify(apiKey));
            localStorage.setItem("id", JSON.stringify(id));
            localStorage.setItem("login", JSON.stringify(login));
            localStorage.setItem("name", JSON.stringify(name));
            localStorage.setItem("clientId", JSON.stringify(clientId));
            localStorage.setItem("contractId", JSON.stringify(contractId));
                        
            getPerfil(id, login, clientId);
            getProducts(id, login)
            
            getproductvalidation(id, login, clientId);        

            dispatch({ type: AuthLogin, payload: datosLogin });
          } else {
            swal({
              title: "Atención",
              text: MSG.MSG_ERROR_CREDENCIALES_LOGIN + response.data.menssage,
              icon: "warning",
            });
          }

          return "OK"
        })
        .catch((error) => {
          swal({
            title: `Atención ${MSG.MSG_ERROR_CREDENCIALES_LOGIN}`,
            text: "",
            icon: "warning",
          });
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const LoginTwo = (skl, prdd) => {
    localStorage.clear();
    localStorage.setItem("log", JSON.parse(false));
    localStorage.setItem("setConditionsProducts", JSON.stringify(true));
    try {
      axios
        .post(`${parametros.URLAPISUCA}api/Authority/impersonate`, {
          slkToken: skl,
          applicationId: parametros.applicationId,
          productId: prdd,
        })
        .then((response) => {

          if (response.status === 200) {
            
            if (response.data.autenticated) {
              const datosLogin = response.data;
              const tokenId = datosLogin.tokenId;
              const token = datosLogin.tokenValue;
              const apiKey = datosLogin.apiKey;
              const id = CodificaString(datosLogin.id);
              const login = CodificaString(datosLogin.login);
              const name = CodificaString(datosLogin.name);
              const clientId = CodificaString(datosLogin.clientId);
              const autenticado = CodificaString(datosLogin.autenticated);
              const contractId = CodificaString(datosLogin.contractId);

              dispatch({ type: AuthLogin, payload: datosLogin });
              localStorage.setItem("skl", JSON.stringify(skl));
              localStorage.setItem("autenticado", JSON.stringify(autenticado));
              localStorage.setItem("jwt", JSON.stringify(token));
              localStorage.setItem("tokenId", JSON.stringify(tokenId));
              localStorage.setItem("apiKey", JSON.stringify(apiKey));
              localStorage.setItem("id", JSON.stringify(id));
              localStorage.setItem("login", JSON.stringify(login));
              localStorage.setItem("name", JSON.stringify(name));
              localStorage.setItem("clientId", JSON.stringify(clientId));
              localStorage.setItem("contractId", JSON.stringify(contractId));              
              getPerfil(id, login);
              getProducts(id, login);
              getUrlBase(id, login);
              getproductvalidation(id, login, clientId);
            
            } else {              

              swal({
                title: "Atención",
                text: MSG.MSG_ERROR_CREDENCIALES_LOGIN + response.data.menssage,
                icon: "warning",
              });
            }
          } else {
            window.location.href = "login";
          }
        });
    } catch (error) {}
  };

  const postLogoutAll = async (id, login) => {
    const idUser = DecodificanString(id);
    const userLogin = DecodificanString(login);
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    try {
      axios
        .post(
          `${parametros.URLAPISUCA}api/authority/logoff`,
          {
            userId: idUser,
            userLogin: userLogin,
            applicationId: parametros.applicationId,
          },
          {
            headers: {
              Authorization: Authorization,
              ApiKey: ApiKey,
            },
          }
        )
        .then((response) => {
          const dataLogout = response.data;
          
          dispatch({ type: LogoutAll, payload: dataLogout });
          
          dispatch({
            type: types.AuthLogout,
          });
          
        })     
    } catch (error) {
      console.warn(error);
    }
  };

  const getQuery = (skl) => {    

    localStorage.setItem("skl", JSON.stringify(skl));
    
  };

  const calculoserie = (rut) => {
    //valido si el rut que viene es empresa o persona natural para poder ocultar la barra de n serie
    if (rut > 50000000) {
      const seriecedulaAccion = true;

      dispatch({ type: ASIGNO_NSERIES_EMPRESA, payload: seriecedulaAccion });
    } else {
      const seriecedulaAccion = false;

      dispatch({ type: ASIGNO_NSERIES_EMPRESA, payload: seriecedulaAccion });
    }
  };
  const calcularNroSerie = (rut) => {
    if (rut) {
      if (rut > 50000000) {
        const seriecedulaAccion = true;

        dispatch({ type: ASIGNO_NSERIES_EMPRESA, payload: seriecedulaAccion });
      } else {
        const seriecedulaAccion = false;

        dispatch({ type: ASIGNO_NSERIES_EMPRESA, payload: seriecedulaAccion });
      }
      let M = 0;
      let S = 1;
      for (; rut; rut = Math.floor(rut / 10))
        S = (S + (rut % 10) * (9 - (M++ % 6))) % 11;

      const digitoVerificador = S ? S - 1 : "K";

      setRutDv(S ? S - 1 : "K");

      dispatch({ type: ASIGNO_DIGITO_VERIFICADOR, payload: digitoVerificador });
      const estado_carga = true;
      dispatch({ type: ASIGNO_ESTADO_CARGA, payload: estado_carga });
      return S ? S - 1 : "K";
    } else {
      dispatch({ type: ASIGNO_DIGITO_VERIFICADOR, payload: null });
      dispatch({ type: ASIGNO_NSERIES_EMPRESA, payload: false });
    }

    //valido si el rut que viene es empresa o persona natural para poder ocultar la barra de n serie
  };

  const tomarRutconsulta = (values) => {
    const RutConsultaform = values.Rut;
    dispatch({ type: ASIGNO_RUT_CONSULTA, payload: RutConsultaform });
  };

  const getInformeComercialNew = async (Rut, Dv, serieCedula) => {
    dispatch({ type: GET_SOCIOS_SOCIEDADES, payload: null });
    dispatch({ type: GET_DETALLE_BOLETIN, payload: null });
    dispatch({ type: GET_DETALLE_PROPIEDADES_BIENES, payload: null });
    dispatch({ type: GET_DETALLE_VEHICULO, payload: null });
    dispatch({ type: GET_DETALLE_CONYUGE, payload: null });
    dispatch({ type: GET_DETALLE_DIRECCIONES, payload: null });
    localStorage.removeItem("imgPdfGrafi");
    dispatch({ type: GET_IC, payload: null });
    dispatch({ type: STATE_OK_LOADING_IC, payload: true });

    if (
      JSON.parse(localStorage.getItem("name")) == null ||
      JSON.parse(localStorage.getItem("name")) === undefined
    ) {
      swal({
        title: "Atención",
        text: MSG.MSG_ERROR_401,
        icon: "warning",
        button: "Ok",
      });
      return;

    } else {
      setRutConsulta(Rut);
      setRutDv(Dv);
      try {
        const response = await axios.get(
          `${parametros.URLAPI}informeComercial`,
          {
            params: {
              rut: Rut,
              dv: RutDv,
              idCliente: DecodificanString(
                JSON.parse(localStorage.getItem("clientId"))
              ),
              idContrato: DecodificanString(
                JSON.parse(localStorage.getItem("contractId"))
              ),
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              serieCedula: serieCedula,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          }
        );
        const dataInformeComercial = await response.data.InformeComercial;
        
        if (response.status === 200 && dataInformeComercial && dataInformeComercial.ID !== 0) {
          localStorage.setItem(
            "score",
            JSON.stringify(
              response.data.InformeComercial.DetalleAntecedentesCrediticios[0]
                .Score
            )
          );
		  const productos = JSON.parse(DecodificanString(localStorage.getItem("prods")));
          if (JSON.parse(localStorage.getItem("productvalidation"))) {
			  const existProd = productos.data.filter( x => x.Id === 0);
			  if (existProd && existProd.length > 0 && existProd[0].Vigente === true) {	// CONTROLA LLAMADO A ESTRUCTURA FINANCIERA
				getInformeEstructura(Rut, RutDv); 
			  }
          }
              
          dispatch({ type: GET_IC, payload: dataInformeComercial });
          dispatch({ type: STATE_OK_LOADING_IC, payload: false });
        } else if ((response.status === 200 && !dataInformeComercial) || (dataInformeComercial && dataInformeComercial.ID === 0)) {
          dispatch({ type: GET_IC, payload: null });
          dispatch({ type: STATE_OK_LOADING_IC, payload: false });

          swal({
            title: "Atención",
            text: MSG.MSG_TRAFICO_RED_CONGESTIONADO,
            icon: "info",
            button: "Aceptar",
          }).then(()=> window.location.reload());

          localStorage.removeItem("score");
          localStorage.removeItem("imgPdfGrafi");          
        } else if (response.status === 401) {
          localStorage.removeItem("score");
          localStorage.removeItem("imgPdfGrafi");
          dispatch({ type: STATE_OK_LOADING_IC, payload: false });
          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_AUTORITETIONS_401,
            icon: "warning",
            button: "OK",
          });

          setTimeout(() => {
            localStorage.clear();
            window.location.href = "/login";
          }, 1000);
          return;
        } else if (response.status === 500) {
          dispatch({ type: code_error, payload: response.status });
          dispatch({ type: STATE_OK_LOADING_IC, payload: false });
        }
      } catch (error) {

        dispatch({ type: STATE_OK_LOADING_IC, payload: false });
      
        if (error && error.status === 401) {
          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_AUTORITETIONS_401,
            icon: "warning",
            button: "OK",
          });

          setTimeout(() => {
            localStorage.clear();
            window.location.href = "/login";
          }, 1000);
        }
      }
    }
  };

  const getInfoComercialModal = async (Rut) => {

    dispatch({ type: GET_SOCIOS_SOCIEDADES_MODAL, payload: null });
    dispatch({ type: GET_DETALLE_BOLETIN_MODAL, payload: null });
    dispatch({ type: GET_DETALLE_PROPIEDADES_BIENES_MODAL, payload: null });
    dispatch({ type: GET_DETALLE_VEHICULO_MODAL, payload: null });
    dispatch({ type: GET_DETALLE_CONYUGE_MODAL, payload: null });
    dispatch({ type: GET_DETALLE_DIRECCIONES_MODAL, payload: null });

    localStorage.removeItem("imgPdfGrafiModal");
    localStorage.removeItem("scoreModal");
    let RutSocios = Rut.split("-");
    
    initialState.datoICMODAL = null;
    setRutConsultaModal(RutSocios[0]);
    setRutDvModal(RutSocios[1]);

    if (
      JSON.parse(localStorage.getItem("name")) == null ||
      JSON.parse(localStorage.getItem("name")) === undefined
    ) {
      swal({
        title: "Atención",
        text: MSG.MSG_ERROR_401,
        icon: "warning",
        button: "Aceptar",
      });
      localStorage.setItem("stateLoading", JSON.stringify(false));
      return;
    
    } else {
      if (RutSocios[0] === null || RutSocios[0] === undefined) {
        swal({
          title: "Atención",
          text: MSG.MSG_ERROR_RUT_VALIDO,
          icon: "warning",
          button: "Aceptar",
        });

        dispatch({
          type: GET_IC_MODAL,
          payload: "ERROR INFORME COMERCIAL MODAL",
        });

        return;
      } else if (RutSocios[0] === "" || RutSocios[0] === "0") {
        swal({
          title: "Atención",
          text: MSG.MSG_ERROR_RUT_VALIDO,
          icon: "warning",
          button: "Aceptar",
        });

        dispatch({
          type: GET_IC_MODAL,
          payload: "ERROR INFORME COMERCIAL MODAL",
        });

        return;
      } else {
        try {
          axios
            .get(`${parametros.URLAPI}informeComercial`, {
              params: {
                rut: RutSocios[0],
                dv: RutSocios[1],
                idCliente: DecodificanString(
                  JSON.parse(localStorage.getItem("clientId"))
                ),
                idContrato: DecodificanString(
                  JSON.parse(localStorage.getItem("contractId"))
                ),
                usuario: DecodificanString(
                  JSON.parse(localStorage.getItem("login"))
                ),
                serieCedula: "",
              },
              headers: {
                Authorization: Authorizationn,
                apiKey: apiKeyy,
                AuthorizationID: AuthorizationIDD,
                ApplicationId: parametros.applicationId,
                User: Userr,
              },
            })
            .then((response) => {
              if (
                response.data.InformeComercial.ID === 0 ||
                response.data.InformeComercial.Fecha == null
              ) {
                response.data = null;
                response.data = [];

                swal({
                  title: "Atención",
                  text: MSG.MGS_SIN_RESULTADO_INFORME,
                  icon: "info",
                  button: "Aceptar",
                });

                const estado_carga = false;
                dispatch({ type: ASIGNO_ESTADO_CARGA, payload: estado_carga });

                setTimeout(() => {
                  dispatch({
                    type: GET_IC_MODAL,
                    payload: "ERROR INFORME COMERCIAL MODAL",
                  });
                }, 400);
              } else {
                const datarepuestainformeComercialModal =
                  response.data.InformeComercial;
                localStorage.setItem(
                  "scoreModal",
                  JSON.stringify(
                    response.data.InformeComercial
                      .DetalleAntecedentesCrediticios[0].Score
                  )
                );
          
                getDetalleDocumentpch(RutSocios[0], RutSocios[1]);

                dispatch({
                  type: GET_IC_MODAL,
                  payload: datarepuestainformeComercialModal,
                });

                if (JSON.parse(localStorage.getItem("productvalidation"))) {                  
                  getInformeEstructuraModal(RutSocios[0], RutSocios[1]);
                }

                const estado_carga = false;
                dispatch({ type: ASIGNO_ESTADO_CARGA, payload: estado_carga });
              }
            })
            .catch((error) => {
              if (error.request.status === 401) {
                swal({
                  title: "Atención",
                  text: MSG.MSG_ERROR_AUTORITETIONS_401,
                  icon: "warning",
                  button: "Aceptar",
                });

                setTimeout(() => {
                  localStorage.clear();
                  window.location.href = "/";
                }, 600);
              }

              console.warn("ERROR " + error.name + " " + error.message);
            });
        } catch (err) {
          console.log(err.message);
        }
      }
    }
  };

  const getDetalleDocumentpch = async (Rut, Dv) => {
    axios
      .get(`${parametros.URLAPI}InformeConsultaPch/informe-consulta-pch`, {
        params: {
          rut: Rut,
          dv: Dv,
        },
        headers: {
          Authorization: Authorizationn,
          apiKey: apiKeyy,
          AuthorizationID: AuthorizationIDD,
          ApplicationId: parametros.applicationId,
          User: Userr,
        },
      })
      .then((response) => {
        const datarepuestadocum = response.data;
    
        dispatch({ type: GET_DOCUMENT_PCH, payload: datarepuestadocum });
      })
      .catch(function (error) {
        if (error.response) {
          const datarepuestadocum = "ERROR CONSULTA DOCUMENTO PCH"          

          dispatch({ type: GET_DOCUMENT_PCH, payload: datarepuestadocum });
        }
      });
  };

  const getLitadeSociosAsociados = async (RutSo, idFolioPrincipal) => {
    
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutListadoSociosAso = RutSo.split("-");
      try {
        axios
          .get(`${parametros.URLAPI}informeComercial/socios-y-sociedades`, {
            params: {
              timeout: 5000,
              rut: RutListadoSociosAso[0],
              dv: RutListadoSociosAso[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const DaListAsociados = response.data;            
            dispatch({ type: GET_SOCIOS_SOCIEDADES, payload: DaListAsociados });
          })
          .catch((error) => {
            const DaListAsociados = "ERROR CONSULTA ASOCIADOS";            

            dispatch({ type: GET_SOCIOS_SOCIEDADES, payload: DaListAsociados });
        
          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getLitadeSociosAsociadosModal = async (RutS, idFolioPrincipal) => {    
    let RutSociosModal = RutS.split("-");
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      axios
        .get(`${parametros.URLAPI}informeComercial/socios-y-sociedades`, {
          params: {
            rut: RutSociosModal[0],
            dv: RutSociosModal[1],
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },

          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
        })
        .then((response) => {
          const DaListAsociadospdf = response.data;      
          dispatch({
            type: GET_SOCIOS_SOCIEDADES_MODAL,
            payload: DaListAsociadospdf,
          });
        })
        .catch(function (error) {
          if (error.response) {
            const DaListAsociadospdf = "ERROR CONSULTA ASOCIADOS";      

            dispatch({
              type: GET_SOCIOS_SOCIEDADES_MODAL,
              payload: DaListAsociadospdf,
            });
          }
        });
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleConyuge = async (RutConsulta, idFolioPrincipal) => {
  
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutConyuge = RutConsulta.split("-");

      try {
        axios
          .get(`${parametros.URLAPI}informeComercial/conyuge`, {
            params: {
              timeout: 5000,
              rut: RutConyuge[0],
              dv: RutConyuge[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const detalleconyuge = response.data;        
            dispatch({ type: GET_DETALLE_CONYUGE, payload: detalleconyuge });
          })
          .catch((error) => {
            const detalleconyuge = "ERROR CONSULTA CONYUGE";            

            dispatch({ type: GET_DETALLE_CONYUGE, payload: detalleconyuge });

          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleConyugeModal = async (RutConsulta, idFolioPrincipal) => {

    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutConyuge = RutConsulta.split("-");

      try {
        axios
          .get(`${parametros.URLAPI}informeComercial/conyuge`, {
            params: {
              timeout: 5000,
              rut: RutConyuge[0],
              dv: RutConyuge[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const detalleconyuge = response.data;
        
            dispatch({
              type: GET_DETALLE_CONYUGE_MODAL,
              payload: detalleconyuge,
            });
          })
          .catch((error) => {
            const detalleconyuge = "ERROR CONSULTA CONYUGE";
          
            dispatch({
              type: GET_DETALLE_CONYUGE_MODAL,
              payload: detalleconyuge,
            });
          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleDirecciones = async (RutConsulta, idFolioPrincipal) => {

    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutDirecciones = RutConsulta.split("-");

      axios
        .get(`${parametros.URLAPI}informeComercial/direcciones`, {
          params: {
            timeout: 5000,
            rut: RutDirecciones[0],
            dv: RutDirecciones[1],
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
          validateStatus: function (status) {
            return status < 500;
          },
        })
        .then((response) => {
          const detalledirecciones = response.data;

          dispatch({
            type: GET_DETALLE_DIRECCIONES,
            payload: detalledirecciones,
          });
        })
        .catch(function (error) {
          if (error.response) {
            const detalledirecciones = "ERROR CONSULTA DIRECCIONES";
            
            dispatch({
              type: GET_DETALLE_DIRECCIONES,
              payload: detalledirecciones,
            });
          }
        });
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleDireccionesModal = async (RutConsulta, idFolioPrincipal) => {
  
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutDirecciones = RutConsulta.split("-");

      axios
        .get(`${parametros.URLAPI}informeComercial/direcciones`, {
          params: {
            timeout: 5000,
            rut: RutDirecciones[0],
            dv: RutDirecciones[1],
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
          validateStatus: function (status) {
            return status < 500;
          },
        })
        .then((response) => {
          const detalledirecciones = response.data;
      
          dispatch({
            type: GET_DETALLE_DIRECCIONES_MODAL,
            payload: detalledirecciones,
          });
        })
        .catch(function (error) {
          if (error.response) {
            const detalledirecciones = "ERROR CONSULTA DIRECCIONES";           

            dispatch({
              type: GET_DETALLE_DIRECCIONES_MODAL,
              payload: detalledirecciones,
            });
          }
        });
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetallePropBienes = async (Rut, idFolioPrincipal) => {
    let RutDetalleProBie = Rut.split("-");
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/propiedades-y-bienes`, {
          params: {
            timeout: 5000,
            rut: RutDetalleProBie[0],
            dv: RutDetalleProBie[1],
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
          validateStatus: function (status) {
            return status < 500; 
          },
        })
        .then((response) => {
          const responsepropiedades = response.data;
          
          dispatch({
            type: GET_DETALLE_PROPIEDADES_BIENES,
            payload: responsepropiedades,
          });
        })
        .catch((error) => {
          const responsepropiedades = "ERROR CONSULTA PROPIEDADES";
          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_SOLICITUD_INTENTE_NUEVO,
            icon: "warning",
            button: "Aceptar",
          });

          dispatch({
            type: GET_DETALLE_PROPIEDADES_BIENES,
            payload: responsepropiedades,
          });

          if (error.request.status === 401) {
            swal({
              title: "Atención",
              text: MSG.MSG.MSG_ERROR_AUTORITETIONS_401,
              icon: "warning",
              button: "OK",
            });

            setTimeout(() => {
              localStorage.clear();
              window.location.href = "/";
            }, 600);
          } else {
          }
      
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getDetallePropBienesModal = async (Rut, idFolioPrincipal) => {
    let RutDetalleProBie = Rut.split("-");
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/propiedades-y-bienes`, {
          params: {
            timeout: 5000,
            rut: RutDetalleProBie[0],
            dv: RutDetalleProBie[1],
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
          validateStatus: function (status) {
            return status < 500;
          },
        })
        .then((response) => {
          const responsepropiedades = response.data;    
          dispatch({
            type: GET_DETALLE_PROPIEDADES_BIENES_MODAL,
            payload: responsepropiedades,
          });
        })
        .catch((error) => {
          const responsepropiedades = "ERROR CONSULTA PROPIEDADES";
          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_SOLICITUD_INTENTE_NUEVO,
            icon: "warning",
            button: "Aceptar",
          });

          dispatch({
            type: GET_DETALLE_PROPIEDADES_BIENES_MODAL,
            payload: responsepropiedades,
          });

          if (error.request.status === 401) {
            swal({
              title: "Atención",
              text: MSG.MSG.MSG_ERROR_AUTORITETIONS_401,
              icon: "warning",
              button: "OK",
            });

            setTimeout(() => {
              localStorage.clear();
              window.location.href = "/";
            }, 600);
          }          
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getDetalleBoletin = async (Rut, idFolioPrincipal) => {

    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutDetalleBoletin = Rut.split("-");

      try {
        axios
          .get(`${parametros.URLAPI}informeComercial/boletin-laboral`, {
            params: {
              timeout: 5000,
              rut: RutDetalleBoletin[0],
              dv: RutDetalleBoletin[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const respboletinlab = response.data;            
            dispatch({ type: GET_DETALLE_BOLETIN, payload: respboletinlab });
          })
          .catch((error) => {
            const respboletinlab = "ERROR CONSULTA";
            swal({
              title: "Atención",
              text: MSG.MSG_ERROR_SOLICITUD_INTENTE_NUEVO,
              icon: "warning",
              button: "Aceptar",
            });

            dispatch({ type: GET_DETALLE_BOLETIN, payload: respboletinlab });
            
            if (error.request.status === 401) {
              swal({
                title: "Atención",
                text: MSG.MSG_ERROR_AUTORITETIONS_401,
                icon: "warning",
                button: "Aceptar",
              });
              setTimeout(() => {
                localStorage.clear();
                window.location.href = "/";
              }, 600);
            }
          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleBoletinModal = async (Rut, Dv, idFolioPrincipal) => {
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/boletin-laboral`, {
          params: {
            rut: Rut,
            dv: Dv,
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
        })
        .then((response) => {
          const respboletinlabpdf = response.data;          
          dispatch({
            type: GET_DETALLE_BOLETIN_MODAL,
            payload: respboletinlabpdf,
          });
        })
        .catch((error) => {
          const respboletinlabpdf = "ERROR CONSULTA";

          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_SOLICITUD_INTENTE_NUEVO,
            icon: "warning",
            button: "Aceptar",
          });

          dispatch({
            type: GET_DETALLE_BOLETIN_MODAL,
            payload: respboletinlabpdf,
          });
          
          if (error.response.status === 401) {
            swal({
              title: "Atención",
              text: MSG.MSG_ERROR_AUTORITETIONS_401,
              icon: "warning",
              button: "Aceptar",
            });

            setTimeout(() => {
              localStorage.clear();
              window.location.href = "/";
            }, 600);
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getDetalleVehiculo = async (Rut, idFolioPrincipal) => {
    
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutDetalleVehiculo = Rut.split("-");
      try {
        axios
          .get(`${parametros.URLAPI}InformeVehiculo/informe-vehiculos`, {
            params: {
              timeout: 5000,
              rut: RutDetalleVehiculo[0],
              dv: RutDetalleVehiculo[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const datavehiculo = response.data;
          
            dispatch({ type: GET_DETALLE_VEHICULO, payload: datavehiculo });
          })
          .catch((error) => {        
            console.log("ERROR " + error.name + ' ' + error.message);
          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleVehiculoModal = async (Rut, idFolioPrincipal) => {
    
    if (
      DecodificanString(JSON.parse(localStorage.getItem("ContratoInfoCom")))
    ) {
      let RutDetalleVehiculo = Rut.split("-");
      try {
        axios
          .get(`${parametros.URLAPI}InformeVehiculo/informe-vehiculos`, {
            params: {
              timeout: 5000,
              rut: RutDetalleVehiculo[0],
              dv: RutDetalleVehiculo[1],
              idCliente: clientIdd,
              idContrato: ContractIdd,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
              idFolioPrincipal: idFolioPrincipal,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const datavehiculo = response.data;
            dispatch({
              type: GET_DETALLE_VEHICULO_MODAL,
              payload: datavehiculo,
            });
          })
          .catch((error) => {          
            console.log("ERROR " + error.name + ' ' + error.message);
          });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "Aceptar",
      });
    }
  };

  const getDetalleExtracto = async (idExtracto, idFolioPrincipal) => {
    
    dispatch({ type: GET_DETALLE_EXTRACTO, payload: null });
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/extracto`, {
          params: {
            rut: RutConsulta,
            dv: RutDv,
            idExtracto: idExtracto,
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
        })
        .then((response) => {
          const dataextracto = response.data;

          dispatch({ type: GET_DETALLE_EXTRACTO, payload: dataextracto });
        })
        .catch((error) => {
          const dataextracto = "ERROR CONSULTA EXTRACTO";

          dispatch({ type: GET_DETALLE_EXTRACTO, payload: dataextracto });          
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getNullDataExtracto = () => {
    dispatch({ type: GET_DETALLE_EXTRACTO, payload: null });
  };

  const getDetalleExtractoModal = async (idExtracto, idFolioPrincipal) => {

    dispatch({ type: GET_DETALLE_EXTRACTO, payload: null });
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/extracto`, {
          params: {
            timeout: 5000,
            rut: RutConsultaModal,
            dv: RutDvModal,
            idExtracto: idExtracto,
            idCliente: clientIdd,
            idContrato: ContractIdd,
            usuario: DecodificanString(
              JSON.parse(localStorage.getItem("login"))
            ),
            idFolioPrincipal: idFolioPrincipal,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
        })
        .then((response) => {
          const dataextracto = response.data;
      
          dispatch({ type: GET_DETALLE_EXTRACTO, payload: dataextracto });
        })
        .catch((error) => {
          const dataextracto = "ERROR CONSULTA EXTRACTO";
          
          dispatch({ type: GET_DETALLE_EXTRACTO, payload: dataextracto });
          
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getInformeEstructura = async (Rut, Dv) => {

    if (JSON.parse(localStorage.getItem("productvalidation"))) {
      
      try {
        axios
          .get(`${parametros.URLAPISUPER}api/analytics/informe`, {
            params: {
              timeout: 5000,
              rut: Rut,
              dv: Dv,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const dataEstructura = response.data;            
            dispatch({
              type: GET_ESTRUCTURA_FINANCIERA,
              payload: dataEstructura,
            });
          })
          .catch((error) => {
            const dataEstructura = "ERROR CONSULTA ASOCIADOS";

            dispatch({
              type: GET_ESTRUCTURA_FINANCIERA,
              payload: dataEstructura,
            });

            console.warn("ERROR " + error.name + " " + error.message);
          });
      } catch (err) {
        console.log(err.message);
      }

    }
  };

  const getInformeEstructuraModal = async (Rut, Dv) => {

    if (JSON.parse(localStorage.getItem("productvalidation"))) {
      
      try {
        axios
          .get(`${parametros.URLAPISUPER}api/analytics/informe`, {
            params: {
              timeout: 5000,
              rut: Rut,
              dv: Dv,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {
            const dataEstructura = response.data;

            dispatch({
              type: GET_ESTRUCTURA_FINANCIERA_MODAL,
              payload: dataEstructura,
            });
          })
          .catch((error) => {
            const dataEstructura = "ERROR CONSULTA ASOCIADOS";            
            dispatch({
              type: GET_ESTRUCTURA_FINANCIERA_MODAL,
              payload: dataEstructura,
            });

            console.warn("ERROR " + error.name + " " + error.message);
          });
      } catch (err) {
        console.log(err.message);
      }
  
    }
  };

  const getDetalleOnp = async (busqueda) => {
    
    const { rut, banco, ctacte, nrodoc, monto, serieRUT } = busqueda;

    localStorage.setItem("busqueda", JSON.stringify(busqueda));
    const clientId = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );

    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const idContrato = DecodificanString(
      JSON.parse(localStorage.getItem("contratoOnp"))
    );

    const { calcularDv } = require("validar-rut");
    const midv = calcularDv(rut);

    try {
      axios
        .get(
          `${parametros.URLAPI}InformeVerificacionONP/informe-verificacion-onp`,
          {
            params: {
              rut: rut,
              dv: midv,
              idCliente: clientId,
              idContrato: idContrato,
              banco: banco,
              ctacte: ctacte,
              nrodoc: nrodoc,
              monto: monto,
              serieRUT: serieRUT,
              usuario: DecodificanString(
                JSON.parse(localStorage.getItem("login"))
              ),
            },
            headers: {
              Authorization: Authorization,
              ApiKey: ApiKey,
              AuthorizationID: tokenId,
              ApplicationId: parametros.applicationId,
              User: login,
            },
          }
        )
        .then((resultado) => {
          const detallesOnp = resultado.data;
          
          dispatch({ type: GetOnp, payload: detallesOnp });
        })
        .catch((error) => {
          swal({
            title: "Atención",
            text: MSG.MSG_ERROR_SOLICITUD_INTENTE_NUEVO,
            icon: "warning",
            button: "Aceptar",
          });

          if (error.response.status === 401) {
            swal({
              title: "Atención",
              text: MSG.MSG_ERROR_AUTORITETIONS_401,
              icon: "warning",
              button: "Aceptar",
            });

            setTimeout(() => {
              localStorage.clear();
              window.location.href = "/";
            }, 600);
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  const getBanco = async () => {
    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));

    const resultado = await axios.get(
      `${parametros.URLAPI}InformeVerificacionONP/bancos`,
      {
        headers: {
          Authorization: Authorization,
          ApiKey: ApiKey,
          AuthorizationID: tokenId,
          ApplicationId: parametros.applicationId,
          User: login,
        },
      }
    );

    const listaBanco = await resultado.data;
    dispatch({ type: GetBanco, payload: listaBanco });
  };

  const Soporte = async (soporte) => {
    const { email, asunto, descripcion } = soporte;

    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const usuario = DecodificanString(
      JSON.parse(localStorage.getItem("login"))
    );

    try {
      const respuesta = await axios.post(
        `${parametros.URLAPI}administracion/soporte`,
        {
          Subject: asunto,
          Email: email,
          Observacion: descripcion,
        },
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
            AuthorizationID: tokenId,
            ApplicationId: parametros.applicationId,
            User: usuario,
          },
        }
      );

      if (respuesta.data.Resultado) {
        const resultado = respuesta.data.Resultado;
      

        dispatch({ type: GetSoporte, payload: resultado });
      } else {
        const mensaje = respuesta.data.Mensaje;
        swal({
          title: "Atención",
          text: mensaje,
          icon: "warning",
          button: "Aceptar",
        });
        dispatch({ type: GetSoporte, payload: respuesta });
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const getUsuarios = async () => {
    const usuario = DecodificanString(
      JSON.parse(localStorage.getItem("login"))
    );
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const clientId = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );

    try {
      const usuarios = await axios.get(
        `${parametros.URLAPI}administracion/usuarios?clienteId=${clientId}`,
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
            AuthorizationID: tokenId,
            ApplicationId: parametros.applicationId,
            User: usuario,
          },
        }
      );

      if (usuarios.status === 200) {
        const listaUsuarios = usuarios.data;
        
        dispatch({ type: GetUsuarios, payload: listaUsuarios });
      }

    } catch (error) {
      console.warn(error);
    }
  };

  const getResumenConsultas = async (
    busquedaConsulta,
    fechaDesde,
    fechaHasta
  ) => {

    const { usuario } = busquedaConsulta;
    const fechaInicio = moment(fechaDesde).format("YYYY-MM-DD");
    const fechaTermino = moment(fechaHasta).format("YYYY-MM-DD"); 


    localStorage.setItem("usuario", JSON.stringify(usuario));
    localStorage.setItem("fechaInicio", JSON.stringify(fechaInicio));
    localStorage.setItem("fechaTermino", JSON.stringify(fechaTermino));

    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const clienteId = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );

    try {
      const Resumen = await axios.get(
        `${parametros.URLAPI}administracion/consultas/resumen?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&clienteId=${clienteId}&usuario=${usuario}`,
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
            AuthorizationID: tokenId,
            ApplicationId: parametros.applicationId,
            User: login,
          },
        }
      );
      const SumarConsultas = () => {
        const listaTotal = Resumen.data.resumen?.map((item) => ({
          tconsulta: item.TotalConsultas,
        }));        

        const sumaConsultas = listaTotal.reduce(
          (prev, next) => prev + next.tconsulta,
          0
        );
        localStorage.setItem("sumaConsultas", JSON.stringify(sumaConsultas));
      };
      if (Resumen.data.resumen.length > 0) {
        const consultasUsuario = Resumen.data;
        SumarConsultas();
        dispatch({ type: GetResumen, payload: consultasUsuario });
      } else {
        const consultasUsuario = Resumen.data;

        dispatch({ type: GetResumen, payload: consultasUsuario });
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const getResumenGrafico = async (consultaAnual, fechaHoy) => {
    const fechaInicio = consultaAnual.format("yyy-MM-DD");
    const fechaTermino = fechaHoy.format("yyy-MM-DD");

    localStorage.setItem("fechaInicio", JSON.stringify(fechaInicio));
    localStorage.setItem("fechaTermino", JSON.stringify(fechaTermino));

    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const clienteId = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );

    try {
      const Resumen = await axios.get(
        `${parametros.URLAPI}administracion/consultas/resumen?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&clienteId=${clienteId}&usuario=`,
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
            AuthorizationID: tokenId,
            ApplicationId: parametros.applicationId,
            User: login,
          },
        }
      );

      const SumarConsultas = () => {
        const listaTotal = Resumen.data.resumen?.map((item) => ({
          tconsulta: item.TotalConsultas,
        }));        

        const sumaConsultasGrafico = listaTotal.reduce(
          (prev, next) => prev + next.tconsulta,
          0
        );
        localStorage.setItem(
          "sumaConsultasGrafico",
          JSON.stringify(sumaConsultasGrafico)
        );
      };

      if (Resumen.data.resumen.length !== 0) {
        const consultasUsuarioGrafico = Resumen.data;
        SumarConsultas();        
        dispatch({ type: GetResumenGrafico, payload: consultasUsuarioGrafico });
      } else {
        const consultasUsuario = Resumen.data[0];
        swal({
          title: "Atención",
          text: MSG.MGS_SIN_RESULTADO_INFORME,
          icon: "warning",
          button: "Aceptar",
        });
        window.location.href = "/log";
        dispatch({ type: GetResumen, payload: consultasUsuario });
      }
    } catch (error) {
      console.warn(error);
    }
  };
  const getDetalleConsulta = async (
    usuarioConsulta,
    fechaDesde,
    fechaHasta
  ) => {
    dispatch({ type: GetDetalle, payload: null });
    const usuario = usuarioConsulta;
    const fechaInicio = fechaDesde;
    const fechaTermino = fechaHasta;    
    const login = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );
    const tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const Authorization = JSON.parse(localStorage.getItem("jwt"));
    const ApiKey = JSON.parse(localStorage.getItem("apiKey"));
    const clienteId = DecodificanString(
      JSON.parse(localStorage.getItem("clientId"))
    );

    try {
      const DetalleConsulta = await axios.get(
        `${parametros.URLAPI}administracion/consultas/detalle?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&clienteId=${clienteId}&usuario=${usuario}`,
        {
          headers: {
            Authorization: Authorization,
            ApiKey: ApiKey,
            AuthorizationID: tokenId,
            ApplicationId: parametros.applicationId,
            User: login,
          },
        }
      );

      if (DetalleConsulta.data.detalles.length > 0) {
        const DetalleUsuario = DetalleConsulta.data;        
        dispatch({ type: GetDetalle, payload: DetalleUsuario });
      } else if (DetalleConsulta.status === 500) {
        window.location.href("/login");
      }
    } catch (error) {
      console.warn(error);
    }
  };

  const getSetvariablenull = () => {
    window.location.href = "/informe";
  };

  const getTipoContracto = async (clientIdd, ContractIdd) => {
    const clienteId = clientIdd;
    const contratoId = ContractIdd;
    const Authorizationn = JSON.parse(localStorage.getItem("jwt"));
    const apiKeyy = JSON.parse(localStorage.getItem("apiKey"));
    const AuthorizationIDD = JSON.parse(localStorage.getItem("tokenId"));
    const Userr = JSON.parse(localStorage.getItem("login"));
    if (clienteId !== "ée" && contratoId !== "ée") {
      try {
        axios
          .get(`${parametros.URLAPI}informeComercial/tipo-contrato`, {
            params: {
              clienteId: clienteId,
              contratoId: contratoId,
            },
            headers: {
              Authorization: Authorizationn,
              apiKey: apiKeyy,
              AuthorizationID: AuthorizationIDD,
              ApplicationId: parametros.applicationId,
              User: Userr,
            },
          })
          .then((response) => {            
            const DataTipoContracto = response.data;
            dispatch({ type: get_TipoContrato, payload: DataTipoContracto }); 
            const codDataTipoContrato = CodificaString(DataTipoContracto) 
            localStorage.setItem("tipCont", codDataTipoContrato)          
            getComsumoPrepago(clientIdd, ContractIdd);

          })
          .catch((error) => {
            console.log("ERROR " + error.name + ' ' + error.message);
            swal({
              title: "Atención",
              text: "Usuario inválido",
              icon: "warning",
              button: "Ok",
            }).then(() => {
              localStorage.clear();
              dispatch({type: types.AuthLogout})
              window.location.href = 'https://www.pch.cl';     
            });
          });
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  const getComsumoPrepago = async (clientIdd, ContractIdd) => {
    const Authorizationn = JSON.parse(localStorage.getItem("jwt"));
    const apiKeyy = JSON.parse(localStorage.getItem("apiKey"));
    const AuthorizationIDD = JSON.parse(localStorage.getItem("tokenId"));
    const Userr = JSON.parse(localStorage.getItem("login"));
    try {
      axios
        .get(`${parametros.URLAPI}informeComercial/consumo-prepago`, {
          params: {
            clienteId: clientIdd,
            contratoId: ContractIdd,
          },
          headers: {
            Authorization: Authorizationn,
            apiKey: apiKeyy,
            AuthorizationID: AuthorizationIDD,
            ApplicationId: parametros.applicationId,
            User: Userr,
          },
        })
        .then((response) => {          
          const dataConsumoPrepago = response.data;          
          dispatch({ type: GetConsumoSaldno, payload: dataConsumoPrepago });          
        })
        .catch((error) => {
          console.log("ERROR " + error.name + ' ' + error.message);
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <UserContext.Provider
      value={{
        dispatch,
        dataCategorie: state.dataCategorie,
        datoIC: state.datoIC,
        datoICMODAL: state.datoICMODAL,
        datoICPDF: state.datoICPDF,
        dataScore: state.dataScore,
        DatoListaSA: state.DatoListaSA,
        DatoListaSApdf: state.DatoListaSApdf,
        DatoListaSAModal: state.DatoListaSAModal,
        DataListaSAModalPdf: state.DataListaSAModalPdf,
        Datodetalleconyuge: state.Datodetalleconyuge,
        DatodetalleconyugeModal: state.DatodetalleconyugeModal,
        DatodetalleDirecciones: state.DatodetalleDirecciones,
        DatodetalleDireccionesModal: state.DatodetalleDireccionesModal,
        DatodetallePropBienes: state.DatodetallePropBienes,
        DatodetallePropBienesModal: state.DatodetallePropBienesModal,
        DatodetalleBoletin: state.DatodetalleBoletin,
        DatodetalleBoletinModal: state.DatodetalleBoletinModal,
        DatodetalleBoletinpdfModal: state.DatodetalleBoletinpdfModal,
        DvValidado: state.DvValidado,
        RutValidado: state.RutValidado,
        dataDetalleEstructura: state.dataDetalleEstructura,
        dataDetalleEstructuraModal: state.dataDetalleEstructuraModal,
        DatodetalleVerificacion: state.DatodetalleVerificacion,
        DatodetalleVehiculos: state.DatodetalleVehiculos,
        DatodetalleVehiculosModal: state.DatodetalleVehiculosModal,
        DatodetalleDocumentpch: state.DatodetalleDocumentpch,
        DatadetalleExtracto: state.DatadetalleExtracto,
        stateLoading: state.stateLoading,
        SerieCedulaNatu: state.SerieCedulaNatu,
        DataOnp: state.DataOnp,
        DataBanco: state.DataBanco,
        DataUsuarios: state.DataUsuarios,

    
        DataLogin: state.DataLogin,
        loadingAuth: state.loadingAuth,
        DataPerfil: state.DataPerfil,
        DataPermisos: state.DataPermisos,
        DataContatoInfoCom: state.DataContatoInfoCom,
        DataContratoVerifOnp: state.DataContratoVerifOnp,
        DataSoporte: state.DataSoporte,

        DataResumen: state.DataResumen,
        DataDetalle: state.DataDetalle,

        DataResumenGrafico: state.DataResumenGrafico,
        DataProducts: state.DataProducts,
        DataLogoutAll: state.DataLogoutAll,
        dataUrlBase: state.dataUrlBase,
        DataTipoContracto: state.DataTipoContracto,
        DataSaldo: state.DataSaldo,
        statOkLoading: state.statOkLoading,
        codeError: state.codeError,

        getResumenGrafico,
        getDetalleConsulta,
        getResumenConsultas,
        getUsuarios,
        Soporte,
        getContractVerifOnp,
        getContractInfoCom,
        getPermisos,
        getPerfil,
        getLogin,
        getInformeEstructura,
        getInformeEstructuraModal,
        getBanco,
        getDetalleOnp,
        getInformeComercialNew,
        getInfoComercialModal,
        getDetalleDocumentpch,
        getLitadeSociosAsociados,
        getLitadeSociosAsociadosModal,
        getDetalleBoletinModal,
        getDetalleConyuge,
        getDetalleConyugeModal,
        getDetalleDirecciones,
        getDetalleDireccionesModal,
        getDetallePropBienes,
        getDetallePropBienesModal,
        getDetalleBoletin,
        getDetalleVehiculo,
        getDetalleVehiculoModal,
        getDetalleExtracto,
        getDetalleExtractoModal,
        getNullDataExtracto,
        calcularNroSerie,
        calculoserie,
        tomarRutconsulta,
        getSetvariablenull,
        getQuery,
        LoginTwo,
        postLogoutAll,
        getTipoContracto,
        getComsumoPrepago,
        getProducts,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
